import { type QuizQuestion, QuizQuestionType } from '@efdigital/ll-addon-data';
import { DataTypeQuiz } from '@efdigital/ll-addon-data/data-types';
import { Type } from '@warp-drive/core/types/symbols';

import { PointsQuestionEditorComponent } from '../editors/question/points.gts';
import { ReportingEditorComponent } from '../editors/reporting/reporting.gts';
import { PointsResponseEditorComponent } from '../editors/response/points.gts';
import { PointsScoringEditorComponent } from '../editors/scoring/points.gts';
import type { QuestionManager } from '../types/question-manager.ts';
import { DEFAULT_RESPONSE } from '../types/quiz-responses.ts';

export const PointsQuestionManager: QuestionManager = {
  discriminator: (question: QuizQuestion) =>
    question.type === QuizQuestionType.Points,
  type: QuizQuestionType.Points,
  icon: 'ph:squares-four-duotone',
  editingIcon: 'ph:squares-four-fill',
  editingLabel: 'Options',
  label: 'Points Question',
  questionComponent: PointsQuestionEditorComponent,
  scoringComponent: PointsScoringEditorComponent,
  responseComponent: PointsResponseEditorComponent,
  reportingComponent: ReportingEditorComponent,
  defaultData: {
    points: {
      [Type]: DataTypeQuiz.QuizQuestionPoints,
      options: [],
      min: 10,
      max: 10,
      response: DEFAULT_RESPONSE,
      response0: DEFAULT_RESPONSE,
    },
    reporting: {
      [Type]: DataTypeQuiz.QuizReportingQuestion,
      groupName: '',
      questionName: '',
    },
  },
};
